import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/servicePage.js";

// Sections for this page
import PriceListing from "./Sections/PriceListing";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function TintPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const items = [
    {name: "Eyebrow Tinting", price: "$15"},
    {name: "Eyelash Tinting", price: "$20"},
    {name: "Eyelash Extensions", price: "$25"}
  ]
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand="Lili's Waxing and Threading Studio"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/extension.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Tinting {"&"} Extensions</h1>
              <h4>
                Enhance your natural brows and lashes. Our team will shape
                your natural arches with Brow Tinting. We don't use any filling or pens.
                Tinting typically lasts 2 weeks.
                Enhance your eyelashes with Extensions
                and have full, long, dark lashes.
              </h4>
              <br />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <PriceListing products={items}/>
        </div>
      </div>
      <Footer />
    </div>
  );
}
